export function toBufferSource(data: unknown): ArrayBuffer | undefined {
  if (!data) return undefined;
  if (data instanceof ArrayBuffer) return data;

  if (ArrayBuffer.isView(data)) {
    // Uint8Array, DataView, etc.
    return data.buffer.slice(
      data.byteOffset,
      data.byteOffset + data.byteLength
    );
  }

  if (Array.isArray(data)) {
    return Uint8Array.from(data).buffer;
  }

  throw new TypeError('Unsupported type: needs a BufferSource');
}
